import { render, staticRenderFns } from "./AssetsAmber.vue?vue&type=template&id=59de68b4&scoped=true"
import script from "./AssetsAmber.vue?vue&type=script&lang=js"
export * from "./AssetsAmber.vue?vue&type=script&lang=js"
import style0 from "./AssetsAmber.vue?vue&type=style&index=0&id=59de68b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de68b4",
  null
  
)

export default component.exports